import { useCallback, useMemo } from "react";
import { useApiService } from "./index";
import {
  ShopVisitReasonItem,
  ShopVisitReasonComponentType,
  UpsertShopVisitReasonRequest,
} from "../types/shopVisitReason";

export const useShopVisitReasonService = () => {
  const { get, post, put, delete: remove } = useApiService();

  const getReasons = useCallback(async (componentType?: ShopVisitReasonComponentType) => {
    const query = componentType
      ? `?componentType=${encodeURIComponent(componentType)}`
      : "";
    const response = await get<ShopVisitReasonItem[]>(`/api/shop-visit-reasons${query}`);
    return response.data;
  }, [get]);

  const createReason = useCallback(async (payload: UpsertShopVisitReasonRequest) => {
    const response = await post<ShopVisitReasonItem>("/api/shop-visit-reasons", payload);
    return response.data;
  }, [post]);

  const updateReason = useCallback(async (id: string, payload: UpsertShopVisitReasonRequest) => {
    const response = await put<ShopVisitReasonItem>(`/api/shop-visit-reasons/${id}`, payload);
    return response.data;
  }, [put]);

  const deleteReason = useCallback(async (id: string, force: boolean = false) => {
    const query = force ? "?force=true" : "";
    await remove(`/api/shop-visit-reasons/${id}${query}`);
  }, [remove]);

  return useMemo(
    () => ({
      getReasons,
      createReason,
      updateReason,
      deleteReason,
    }),
    [getReasons, createReason, updateReason, deleteReason]
  );
};
